import { JWEInvalid } from '../util/errors.js';
const checkCekLength = (cek, expected) => {
    const actual = cek.byteLength << 3;
    if (actual !== expected) {
        throw new JWEInvalid(`Invalid Content Encryption Key length. Expected ${expected} bits, got ${actual} bits`);
    }
};
export default checkCekLength;



// WEBPACK FOOTER //
// ./~/jose/dist/browser/runtime/check_cek_length.js